import React from "react";
import { ReactComponent as DuroltLogoIcon } from "../assets/images/durolt_logo_new.svg";

const BookingSummary = ({ bookingLockerHandler, selectedLockers, address, 	handleLockerBooking = () => {} }) => {

  const lockers = [
    {
      id: 1,
      name: "Medium Locker",
      durations: [
        { label: "0-3 hours", price: 50 },
        { label: "3-6 hours", price: 80 },
        { label: "6-12 hours", price: 120 }
      ]
    },
    {
      id: 2,
      name: "Large Locker",
      durations: [
        { label: "0-3 hours", price: 80 },
        { label: "3-6 hours", price: 120 }
      ]
    },
    {
      id: 3,
      name: "Small Locker",
      durations: [
        { label: "200/day", price: 200 }
      ]
    }
  ];

  // use selectedLockers if available
	const lockerList =
		selectedLockers &&  selectedLockers.length > 0
		? selectedLockers
		: lockers;

	const handlerCLick = () => {
		bookingLockerHandler();
	};

	const handlePayment = ()=>{
		// make the payload for advance reserver api call and then call the login process from the lockerSize page not from here beacuse it is component so
		// we can use the function 
		handleLockerBooking()
		console.log("lockerList is; ", lockerList);
	}

	return (
	<div className="booking-summary">
		<div className="logo">
			<DuroltLogoIcon width={100} height={40} />
		</div>
		<h2 className="title">
			Kindly confirm the details <br /> of your booking
		</h2>
		<div className="location">
			{address ? address : "Pune"}
		</div>
		{/* Scrollable section */}
		<div className="locker-list">
			{lockerList.map((locker) => (
				<div className="locker-card" key={locker.id}>
					<div className="locker-info">
						<span className="locker-name">{locker.name}</span>
						<select className="time-select">
						{locker.durations.map((duration, index) => (
							<option key={index} value={duration.price}>
							{duration.label}
							</option>
						))}
						</select>
						<span className="price">
						₹{locker.durations[0].price}
						</span>
					</div>
				</div>
			))}
			<div className="add-locker" onClick={handlerCLick}>
				Add another locker
			</div>
			<div className="total-section">
				<span>Total payable amount</span>
				<span className="total-price">
				₹{lockerList.reduce(
					(total, item) => total + item.durations[0].price,
					0
				)}
				</span>
			</div>
		</div>

		{/* Fixed Footer */}
		<div className="buttons">
			<button onClick={handlePayment} className="pay-btn">Proceed to pay</button>
			<button className="cancel-btn">Cancel</button>
		</div>
	</div>
	);
};

export default BookingSummary;